import React from "react";

const Switch = ({ onClick, active }) => {
  return (
    <div onClick={onClick} style={{ cursor: "pointer" }}>
      <div
        style={{
          width: "40px",
          height: "20px",
          backgroundColor: active ? "#176197" : "grey",
          borderRadius: "10px",
          position: "relative",
        }}
      >
        <div
          style={{
            width: "18px",
            height: "18px",
            backgroundColor: "white",
            borderRadius: "50%",
            position: "absolute",
            top: "1px",
            left: active ? "20px" : "2px",
            transition: "left 0.2s",
          }}
        />
      </div>
    </div>
  );
};

export default Switch;
